import findCompanionAdSlots from '../../../utils/findCompanionAdSlots';
export default class CompanionAd {
    display = (ad) => {
        if (!ad) {
            return;
        }
        let el;
        const companionAdSlots = findCompanionAdSlots();
        if (companionAdSlots.length > 0) {
            const elementId = companionAdSlots[0].getSlotElementId();
            const container = document.getElementById(elementId);
            if (container) {
                if (container.firstChild) {
                    container.removeChild(container.firstChild);
                }
                if (ad.htmlResource) {
                    el = this.#renderHtmlResource(ad);
                }
                else if (ad.staticResource) {
                    el = this.#renderStaticResource(ad);
                }
                else {
                    googletag.display(elementId);
                    googletag.pubads().refresh();
                    return;
                }
                if (el) {
                    el.setAttribute('id', 'instream-ad-companion');
                    el.setAttribute('aria-label', 'Advertisement');
                }
                container.appendChild(el);
                return el;
            }
        }
    };
    #renderStaticResource({ staticResource, trackingEvents, companionClickTracking, companionClickThrough, }) {
        const div = document.createElement('div');
        if (companionClickTracking) {
            div.onclick = () => {
                fetch(companionClickTracking, {
                    mode: 'no-cors',
                });
            };
        }
        const trackingPixels = trackingEvents
            ?.filter(trackingEvent => trackingEvent.eventType === 'creativeView')
            .reduce((acc, cur) => acc.concat(cur.beaconUrls), []) || [];
        div.innerHTML = `
      <a data-testid="static-res-link" href="${companionClickThrough}" target="_blank" style="display: inline-block">
       <img data-testid="static-res-img" src="${staticResource}" width="100%" />
      </a>
      ${trackingPixels.map(trackingPixel => `<img style="width: 1px; height: 1px; visibility: hidden;" aria-hidden="true" src="${trackingPixel}" />`)}`;
        return div;
    }
    #renderHtmlResource({ htmlResource, width, height }) {
        const iframe = document.createElement('iframe');
        iframe.width = width;
        iframe.height = height;
        if (htmlResource) {
            iframe.srcdoc = htmlResource;
        }
        return iframe;
    }
}
